import LoginCard from "../components/Card/LoginCard";

function Login() {
  return (
    <div
      className="flex flex-1 items-center justify-center"
      style={{
        background:
          "linear-gradient(rgb(225, 223, 244) 0%, rgb(140, 178, 239) 100%)",
      }}
    >
      <LoginCard />
    </div>
  );
}

export default Login;
